export{Swiper as default}from"./Swiper";